'use client';
import { useState, useEffect } from 'react';
import { RenderRTE } from '@/components-2.0/structure/RenderRTE';
import { Document } from '@contentful/rich-text-types';

interface Props {
    asW2?: boolean;
    text?: Document;
}

export default function ClientTextContent({ text, asW2 }: Props) {
    const [textData, setTextData] = useState<Document | undefined>();

    useEffect(() => {
        setTextData(text);
    }, [text]);

    return (
        <>{textData ? <RenderRTE contentfulDoc={textData} /> : <div style={{ minHeight: '80vh' }}></div>}</>
    );
}
